// 公司帳號第一次 SSO 登入回 409 SSO_NOT_LINKED（reason = no_account）之後的「待連結組織」（kq Q143、審查 F14）：
// 網域還沒驗證的組織用 email 查不到（sso/discover），員工又還不是成員、組織頁看不到它 → 登入（或註冊、驗證 email）之後
// 要能直接走這個組織的〔以公司帳號驗證〕（mode = link）。no_account 回應不帶 org_id，所以 begin（mode = login）前先記下。
// 放 localStorage（註冊 / 驗證信可能在別的分頁完成）、7 天到期；org_id 不是機密。讀寫失敗就當沒有。
const KEY = 'kinio.vms.ssoLinkOrg';
const TTL_MS = 7 * 24 * 3600 * 1000;

interface Stored {
  org_id: string;
  at: number;
  /** SSO 回了 no_account：登入後要提示連結 */
  pending?: boolean;
  /** 已經按了〔以公司帳號驗證〕、正在 IdP 來回 */
  linking?: boolean;
  /** 第一次在登入後顯示時綁上的使用者（共用電腦換人登入不顯示別人的組織；審查 P2-2） */
  user_id?: string;
}

function read(): Stored | null {
  try {
    const raw = localStorage.getItem(KEY);
    const v = raw ? (JSON.parse(raw) as Stored) : null;
    return v && typeof v.org_id === 'string' && Date.now() - v.at < TTL_MS ? v : null;
  } catch {
    return null;
  }
}

function write(v: Stored | null): void {
  try {
    if (v) localStorage.setItem(KEY, JSON.stringify(v));
    else localStorage.removeItem(KEY);
  } catch {
    /* 無 storage：登入後看不到提示，照字串表的說明到組織頁 */
  }
}

/** SSO 登入（mode = login）begin 前：記下是哪個組織。 */
export function noteSsoLoginOrg(orgId: string): void {
  write({ org_id: orgId, at: Date.now() });
}

/** /sso/done 拿到 no_account：把剛記下的組織標成待連結。 */
export function markSsoNoAccount(): void {
  const v = read();
  if (v) write({ ...v, pending: true, linking: false, at: Date.now() });
}

/** 登入後要提示連結的組織；沒有 → null。第一次看到時綁上目前使用者，之後換人登入就不顯示。 */
export function pendingSsoLinkOrg(userId?: string): string | null {
  const v = read();
  if (!v?.pending) return null;
  if (userId && v.user_id && v.user_id !== userId) return null;
  if (userId && !v.user_id) write({ ...v, user_id: userId });
  return v.org_id;
}

/** 按了〔以公司帳號驗證〕（mode = link）。 */
export function markSsoLinking(): void {
  const v = read();
  if (v) write({ ...v, linking: true });
}

/** /sso/done 成功：剛才是連結這個組織就清掉；SSO 登入成功（沒走到 no_account）也清。 */
export function ssoDoneOk(): void {
  const v = read();
  if (v && (v.linking || !v.pending)) write(null);
}

/** 連結沒成功：還有機會成功的（EMAIL_NOT_VERIFIED、網路）留著待連結、登入後提示再出現；其他（已連過、沒資格…）清掉，免得每次登入都冒出來。 */
export function ssoLinkFailed(code: string): void {
  const v = read();
  if (!v?.linking) return;
  if (code === 'EMAIL_NOT_VERIFIED' || code === 'NETWORK' || code === 'default') write({ ...v, linking: false });
  else write(null);
}

/** 〔略過〕或連結完成。 */
export function clearSsoLink(): void {
  write(null);
}
